import React, { useContext, useEffect } from "react";
import Head from "next/head";
import { ThemeProvider, CSSReset } from "@chakra-ui/core";
import customTheme from "styles/theme";
import "focus-visible/dist/focus-visible";
import { Global, css } from "@emotion/core";

import { StoreProvider } from "context/ContextStore";
import { AuthProvider } from "context/Auth";

///
import "firebase/firestore";
import "firebase/auth";
import { Fuego, FuegoProvider } from "@nandorojo/swr-firestore";

import * as Sentry from "@sentry/node";

import Layout from "components/shared/Layout";

// import dynamic from "next/dynamic";

// const CrispWithNoSSR = dynamic(() => import("../components/support/crisp"), { ssr: false });

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_PUBLIC_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
};

const fuego = new Fuego(firebaseConfig);
///

const GlobalStyles = css`
  html {
    scroll-behavior: smooth;
  }
  /* This will hide the focus indicator if the element receives focus via the mouse, but it will still show up on keyboard focus. */
  .js-focus-visible :focus:not([data-focus-visible-added]) {
    outline: none;
    box-shadow: none;
  }
  .hideScrollbar::-webkit-scrollbar {
    display: none;
  }
  .truncatedText {
    display: block; /* Fallback for non-webkit */
    height: 13px * 1.6 * 2; /* Fallback for non-webkit */
    display: -webkit-box;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.6;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  /* position: absolute makes the order modal window (FoodModal) scroll to top when clicking, so this is a quick and dirty fix */
  [type="checkbox"],
  [type="radio"] {
    position: relative !important;
  }
`;

if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
  Sentry.init({
    enabled: process.env.NODE_ENV === "production",
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  });
}

function MyApp({ Component, pageProps, err }) {
  return (
    <ThemeProvider theme={customTheme}>
      <FuegoProvider fuego={fuego}>
        <AuthProvider>
          <StoreProvider>
            <CSSReset />
            {/* <CrispWithNoSSR /> */}
            <Head>
              <meta charSet="utf-8" />
              <meta name="viewport" content=" width=device-width, initial-scale=1.0" />
              <link rel="icon" type="image/png" sizes="48x48" href="/images/favicon-48.png" />

              <link rel="preload" href="/fonts/AvertaPE-Semibold.woff" as="font" crossOrigin="" />
              <link rel="preload" href="/fonts/AvertaPE-Semibold.woff2" as="font" crossOrigin="" />
              <link rel="preload" href="/fonts/AvertaPE-Bold.woff" as="font" crossOrigin="" />
              <link rel="preload" href="/fonts/AvertaPE-Bold.woff2" as="font" crossOrigin="" />

              <link href="/css/fonts.css" rel="stylesheet" />
            </Head>
            <Global styles={GlobalStyles} />
            {/* Sentry workaround for https://github.com/vercel/next.js/issues/8592 */}
            <Layout>
              <Component {...pageProps} err={err} />
            </Layout>
          </StoreProvider>
        </AuthProvider>
      </FuegoProvider>
    </ThemeProvider>
  );
}

export default MyApp;
